[
    "ormeau",
    "acétate",
    "glycéride de saindoux hydrogéné acétylé",
    "lanoline acétylée",
    "alcool de lanoline acétylé",
    "ricinoleate de lanoline acétylé",
    "suif acétylé",
    "lait acidophile",
    "adrénaline",
    "surrénales de bovins",
    "surrénales de porcs",
    "surrénales de moutons",
    "placenta",
    "alanine",
    "alcloxa",
    "alcool aliphatique",
    "alligator",
    "peau d'alligator",
    "acides alpha-hydroxy",
    "ambre gris",
    "amerachol",
    "amerchol l101",
    "acide aminiuccinate",
    "caséinate d'ammonium",
    "liquide amniotique",
    "protéine animale hydrolysée isotérique ampd",
    "amylase",
    "anchois",
    "anchois",
    "angora",
    "os d'animaux",
    "acides aminés de collagène animal",
    "graisse animale",
    "graisses animales",
    "graisses et huiles animales",
    "poils d'animaux",
    "acides aminés de kératine animale",
    "huile animale",
    "huiles animales",
    "placenta animal",
    "dérivé de protéine animale",
    "extrait de tissu animal",
    "acide arachidonique",
    "propionate d'arachidyle",
    "astrakan",
    "lard de dos",
    "graisse dorsale",
    "lard",
    "bar",
    "alcool batylique",
    "isostéarate batylique",
    "ours",
    "pollen d'abeille",
    "produits d'abeille",
    "bœuf",
    "cœur de bœuf",
    "foie de bœuf",
    "langue de bœuf",
    "pollen d'abeille",
    "cire d'abeille",
    "rayon de cire d'abeille",
    "lard de ventre",
    "protéine animale hydrolysée benzyltrimonium",
    "bison",
    "sang",
    "fractionnement du plasma sanguin",
    "langue de sang",
    "soies de sanglier",
    "jambon bouilli",
    "cendre d'os",
    "charbon d'os",
    "charbon d'os/noir d'os",
    "charbon de bois d'os",
    "terre d'os",
    "farine d'os",
    "phosphate d'os",
    "soupe d'os",
    "os/farine d'os",
    "noir d'os",
    "farine d'os",
    "bonite",
    "albumine sérique bovine",
    "extrait de cerveau",
    "bratwurst",
    "fromage de tête",
    "lard de petit-déjeuner",
    "bresaola",
    "bruehwurst",
    "bruhwurst",
    "buffle",
    "lait de bufflonne",
    "viande de brousse",
    "beurre",
    "graisse de beurre",
    "solides de beurre",
    "babeurre",
    "poudre de babeurre",
    "huile piscine c30-46",
    "calamars",
    "calciphérol",
    "calciferool",
    "caséinate de calcium",
    "foie de veau",
    "peau de veau",
    "extrait de peau de veau",
    "lait de chamelle",
    "lard canadien",
    "cantharidine",
    "teinture de cantharides",
    "capiz",
    "triglycéride caprylique",
    "carbamide",
    "caribou",
    "carmin",
    "carmin cochenille acide carminique",
    "carmin/acide carminique",
    "carminique",
    "acide carminique",
    "carotène",
    "carotène provitamine a bêta carotène",
    "carpe",
    "caséine",
    "caséine caséinate",
    "caséinate",
    "caséinogène",
    "cachemire",
    "castor",
    "castor castoreum",
    "castoreum",
    "poisson-chat",
    "catgut",
    "catharidine",
    "caviar",
    "caviar(e)",
    "caviar",
    "cera flava",
    "cérébrosides",
    "ceteth",
    "ceteth-02",
    "ceteth-1",
    "ceteth-10",
    "ceteth-2",
    "ceteth-30",
    "ceteth-4",
    "ceteth-6",
    "lactate de cétyle",
    "myristate de cétyle",
    "chamois",
    "fromage",
    "poulet",
    "poitrine de poulet",
    "foie de poulet",
    "pain de poulet",
    "jambon haché",
    "chitosan",
    "cholestérine",
    "cholestérol",
    "bitartrate de choline",
    "chondroïtine",
    "jambon haché",
    "chorizo",
    "chymotrypsine",
    "beurre clarifié",
    "crème caillée",
    "cochenille",
    "morue",
    "huile de foie de morue",
    "charcuterie",
    "coleth-24",
    "collagène",
    "hydrolysat de collagène",
    "lait concentré",
    "glaçage de confiserie",
    "jambon cuit",
    "viandes cuites",
    "corail",
    "corned-beef",
    "poule de Cornouailles",
    "corticostéroïde",
    "corticostéroïde",
    "cortisone corticostéroïde",
    "cotechino",
    "fromage blanc",
    "crabe",
    "chair de crabe",
    "écrevisse",
    "écrevisse",
    "crème",
    "crustacés",
    "caillé",
    "flan",
    "cystéine, forme l",
    "cystine",
    "viande brune",
    "dashi",
    "phosphate dea-oleth-10",
    "cerf",
    "viande de cerf",
    "lactosérum délactosé",
    "charcuterie",
    "lactosérum déminéralisé",
    "acide désoxyribonucléique",
    "collagène animal désamidé",
    "collagène désamidé",
    "désamidocollagène",
    "devon",
    "cystine dicapryloyle",
    "tricaséinamide de diéthylène",
    "dihydrocholestérol",
    "octylédécanoate de dihydrocholestérol",
    "dihydrocoleth-15",
    "dihydrocoleth-30",
    "chlorure de benzylmonium de suif dihydrogéné",
    "méthylamine de suif dihydrogéné",
    "phtalate de suif dihydrogéné",
    "oxyde d'amine de suif dihydroxyéthyle",
    "talloamine hydrogénée diméthylique",
    "stéariamine diméthylique",
    "talloamine diméthylique",
    "glutamate de suif hydrogéné disodique",
    "glutamate de suif hydrogéné disodique",
    "disulfosuccinate de tallamido mea disodique",
    "dipropionate de tallowamino disodique",
    "chlorure de ditallowdimonium",
    "adn",
    "duvet",
    "babeurre sec",
    "jaune d'œuf sec",
    "solides de lait sec",
    "lait entier sec",
    "canard",
    "lard de canard",
    "foie de canard",
    "substances du duodénum",
    "pain hollandais",
    "colorants",
    "e120",
    "e441",
    "e542",
    "e904",
    "e913",
    "phosphate d'os comestible",
    "œuf",
    "albumine d'œuf",
    "albumine/albumine d'œuf",
    "albumine d'œuf",
    "huile d'œuf",
    "poudre d'œuf",
    "protéine d'œuf",
    "blancs d'œufs",
    "jaune d'œuf",
    "extrait de jaune d'œuf",
    "jaunes d'œufs",
    "œufs",
    "édredon",
    "élastine",
    "lard d'élan",
    "extrait d'embryon",
    "émeu",
    "huile d'émeu",
    "huile epiderm r",
    "ergistérol",
    "ergostérol",
    "benzoate d'estradiol",
    "œstrogène",
    "œstrogène estradiol",
    "œstrogène/estradiol",
    "estrone",
    "arachidonate d'éthyle",
    "ester éthylique de protéine animale hydrolysée",
    "lipinéate d'éthyle",
    "lipinéate d'éthyl morrhuate",
    "éthyl morrhuatelipinéate",
    "éthylarachidonate",
    "amide de suif déshydrogéné d'éthylène",
    "lait évaporé",
    "lait de brebis",
    "lait écrémé",
    "yaourt allégé",
    "acides gras",
    "plumes",
    "lait de chamelle fermenté",
    "crème fermentée",
    "lait fermenté",
    "poisson",
    "glycérides de poisson",
    "foie de poisson",
    "huile de foie de poisson",
    "foies de poisson",
    "huile de poisson",
    "sauce de poisson",
    "écailles de poisson",
    "sauce poisson",
    "huile de flétan",
    "fourrure",
    "gel",
    "gélatine",
    "gel de gélatine",
    "gélatine(e)",
    "gélatine",
    "gelbwurst",
    "ghee",
    "gésiers",
    "glucose tyrosinase",
    "acide glucuronique",
    "glycérides",
    "glycérine glycérol",
    "glycérine",
    "lanolate de glycéryle",
    "glycéryles",
    "glycol",
    "glycreth-26",
    "chèvre",
    "fromage de chèvre",
    "lait de chèvre",
    "oie",
    "plumes isolantes d'oie",
    "foie d'oie",
    "bœuf haché",
    "tétras",
    "guanine",
    "essence de perle de guanine",
    "guanine/essence de perle",
    "pintade",
    "lard gitan",
    "églefin",
    "poils de porcs",
    "flétan",
    "jambon",
    "pain au jambon et fromage",
    "fromage de tête",
    "crème épaisse",
    "heptylundécanol",
    "cuir",
    "colle de cuir",
    "lait homogénéisé",
    "miel",
    "rayon de miel",
    "cheval",
    "crin de cheval",
    "viande de cheval",
    "crin de cheval",
    "poil de porc",
    "hot-dog",
    "protéine placentaire humaine",
    "extrait ombilical humain",
    "acide hyaluronique",
    "protéine placentaire humaine hydrolysée",
    "glycéride animal hydrogéné",
    "amine de ditallow hydrogénée",
    "ditalloamine hydrogénée",
    "miel hydrogéné",
    "laneth-20 hydrogéné",
    "laneth-25 hydrogéné",
    "laneth-5 hydrogéné",
    "lanoline hydrogénée",
    "alcool de lanoline hydrogéné",
    "glycéride de saindoux hydrogéné",
    "huile de foie de requin hydrogénée",
    "acide de suif hydrogéné",
    "bétaïne de suif hydrogéné",
    "glycéride de suif hydrogéné",
    "élastine animale hydrolysée",
    "kératine animale hydrolysée",
    "protéine animale hydrolysée",
    "caséine hydrolysée",
    "élastine hydrolysée",
    "protéine placentaire humaine hydrolysée",
    "kératine hydrolysée",
    "protéine de lait hydrolysée",
    "soie hydrolysée",
    "lanoline hydroxylée",
    "crème glacée",
    "urée imidazolidinyle",
    "caséinate de fer",
    "colle de poisson",
    "lanoline isobutylée",
    "lanolate d'isopropyle",
    "isopropyl tallowatelisopropyl lanolate",
    "palmitate d'isopropyle",
    "palmitate d'isopropyle",
    "protéine animale hydrolysée isostéarique",
    "protéine animale hydrolysée isostéaroyle",
    "jagdwurst",
    "bajoue",
    "kangourou",
    "katsuobushi",
    "katsuobushi (okaka)",
    "kératine",
    "acides aminés de kératine",
    "l-cystéine",
    "chlorhydrate de l-cystéine",
    "forme l",
    "lait réduit en lactose",
    "lactalbumine",
    "acide lactique du lactosérum",
    "levures lactiques",
    "acide lactique",
    "lactoferrine",
    "lactoglobuline",
    "lactose",
    "lait sans lactose",
    "lactulose",
    "agneau",
    "lard d'agneau",
    "laneth",
    "laneth-10",
    "laneth-11",
    "laneth-12",
    "laneth-13",
    "laneth-14",
    "laneth-15",
    "laneth-16",
    "laneth-17",
    "laneth-18",
    "laneth-19",
    "laneth-20",
    "laneth-21",
    "laneth-22",
    "laneth-23",
    "laneth-24",
    "laneth-25",
    "laneth-26",
    "laneth-27",
    "laneth-28",
    "laneth-29",
    "laneth-30",
    "laneth-31",
    "laneth-32",
    "laneth-33",
    "laneth-34",
    "laneth-35",
    "laneth-36",
    "laneth-37",
    "laneth-38",
    "laneth-39",
    "laneth-40",
    "laneth-5",
    "laneth-6",
    "laneth-7",
    "laneth-8",
    "laneth-9",
    "acétate de laneth-9",
    "acétate de laneth10",
    "lanogène",
    "lanoïnamide dea",
    "lanoline",
    "acide de lanoline",
    "acides de lanoline",
    "alcool de lanoline",
    "alcools de lanoline",
    "linoléate de lanoline",
    "huile de lanoline",
    "ricinoleate de lanoline",
    "cire de lanoline",
    "lanoline(e)",
    "lanoline",
    "lanoline: acide de lanoline",
    "lanoïnamide dea",
    "lanostérol",
    "lanostérols",
    "saindoux",
    "glycéride de saindoux",
    "protéine animale hydrolysée lauroyle",
    "cuir",
    "lécithine bitartrate de choline",
    "lécithine bitartrate de choline",
    "lipase",
    "foie",
    "extrait de foie",
    "pâté de foie",
    "homard",
    "lait allégé",
    "yaourt allégé",
    "éponge luna",
    "éponge luna",
    "pain de déjeuner",
    "viandes de déjeuner",
    "charcuterie",
    "maquereau",
    "caséinate de magnésium",
    "lanolate de magnésium",
    "tallowate de magnésium",
    "lait malté",
    "extrait mammaire",
    "huile marine",
    "soupe de moelle",
    "mayonnaise",
    "protéine animale hydrolysée mea",
    "viande",
    "pain de viande",
    "boulette de viande",
    "poulet séparé mécaniquement",
    "huile de menhaden",
    "méthionine",
    "mettwurst",
    "lait",
    "chocolat au lait",
    "dérivé de lait",
    "lait de mammifères",
    "lait en poudre",
    "protéine de lait",
    "peau de lait",
    "sucre de lait",
    "matière grasse lactique",
    "lait en poudre",
    "bœuf haché",
    "viande hachée",
    "huile de vison",
    "dilamamine minkamidopropyle",
    "mohair",
    "mollusques",
    "lotte",
    "élan",
    "mortadelle",
    "huile de mossbunker",
    "mucopolysaccharides",
    "mulet",
    "extrait musculaire",
    "musc ambrette",
    "moule",
    "moules",
    "mouton",
    "acide myristique",
    "protéine animale hydrolysée myristoyle",
    "myristyle",
    "myristyles",
    "arôme naturel de beurre",
    "rouge naturel 4",
    "cou",
    "lait écrémé",
    "nougat",
    "océnol",
    "poulpe",
    "okaka",
    "diméthylamine hydrolysée oléamidopropyle protéine animale",
    "oléostéarine",
    "oléostéarine",
    "protéine animale hydrolysée oléoyle",
    "oleths",
    "arachidate d'oléyle",
    "bétaïne oléyle",
    "imidazoline oléyle",
    "lanolate d'oléyle",
    "oléate d'oléyle",
    "stéarate d'oléyle",
    "alcool oléylique océnol",
    "oléylimidazoline",
    "acides gras oméga-3",
    "opossum",
    "viande d'organes",
    "abats",
    "organes",
    "autruche",
    "ovalbumine",
    "extrait ovarien",
    "bile de bœuf",
    "fiel de bœuf",
    "fiel de bœuf",
    "huître",
    "huîtres",
    "protéine de lait hydrolysée palmitoyle",
    "protéine animale hydrolysée palmitoyle",
    "pancetta",
    "paracaséine",
    "perdrix",
    "lait pasteurisé",
    "perle",
    "essence de perle",
    "amide de suif hydrogéné peg-13",
    "polyamine de suif peg-15",
    "solides de lait peg-2",
    "tallowate peg-20",
    "tallowate de glycéryle peg-28",
    "huile et cire de lanoline peg-75",
    "glycérides de poisson hydrogénés peg-8",
    "pentahydrosqualène",
    "pepsine",
    "perhydrosqualène",
    "glaçage pharmaceutique",
    "faisan",
    "épaule de pique-nique",
    "extrait de peau de porc",
    "placenta",
    "polypeptides protéine placentaire",
    "enzymes placentaires",
    "extrait placentaire",
    "protéine placentaire",
    "plie",
    "huile de pogy",
    "lieu",
    "polytéthylène",
    "éther cétylique de polytéthylène",
    "polyglycérol",
    "éther d'alcool de lanoline polyglycéryle-2",
    "polypeptides protéine",
    "pancréas porcin",
    "porc",
    "graisse de porc",
    "rouleau de porc",
    "caséinate de potassium",
    "tallowate de potassium",
    "protéine animale hydrolysée undécylénoyle de potassium",
    "volaille",
    "lanoline ppg-12-peg-50",
    "éther méthylique ppg-2",
    "ppg-5-ceteth-20",
    "ppg-10",
    "éther de glucose méthylique ppg-20",
    "éther cétylique ppg-30",
    "éther de lanoline ppg-30",
    "crevette",
    "acétate de pregnénolone",
    "pristane",
    "propolis",
    "prosciutto",
    "provitamine a",
    "huile purcelline syn",
    "caille",
    "quaternium 27",
    "lapin",
    "viande rouge",
    "lait allégé",
    "yaourt allégé",
    "caséine de présure",
    "glaçage résineux",
    "réticuline",
    "rétinol",
    "rôti de bœuf",
    "porc rôti",
    "œufs de poisson",
    "gelée royale",
    "zibeline",
    "pinceaux de zibeline",
    "isomérate de saccharide",
    "salami",
    "salceson",
    "saumon",
    "sardine",
    "saucisse",
    "saucisses",
    "coquille Saint-Jacques",
    "coquilles Saint-Jacques",
    "éponge de mer",
    "huile de tortue de mer",
    "éponge marine",
    "albumine sérique",
    "protéines sériques",
    "huile de foie de requin",
    "huile de foie de requin",
    "lait de brebis",
    "peau de mouton",
    "peau de mouton",
    "gomme laque",
    "glaçage résineux de gomme laque",
    "cire de gomme laque",
    "épaule",
    "crevette",
    "shrimph",
    "lard de côté",
    "soie",
    "acides aminés de soie",
    "poudre de soie",
    "poudre de soie",
    "lait écrémé",
    "peau",
    "lard de dalle",
    "viandes tranchées",
    "jambon fumé",
    "escargot",
    "escargots",
    "serpent",
    "vivaneau",
    "sodium / tea-lauroyle protéine animale hydrolysée",
    "sodium / tea-undécylénoyle protéine animale hydrolysée",
    "caséinate de sodium",
    "sodium coco-protéine animale hydrolysée",
    "sodium soja protéine animale hydrolysée",
    "sulfate de suif sodique",
    "tallowate de sodium",
    "undécylénate de sodium",
    "lactylate de sodium stéroyle",
    "lactylate de sodium stéroyle",
    "collagène soluble",
    "crème aigre",
    "lait aigre",
    "solides de lait aigre",
    "lait aigre",
    "imidazoline de soja hydroxyéthyle",
    "huile de sperme",
    "intestins de cachalot",
    "spermaceti",
    "palmitate de cétyle spermacétique huile de sperme",
    "extrait de rate",
    "éponge (luna et mer)",
    "pigeonneau",
    "calmar",
    "écureuil",
    "steak",
    "amine stéryldiméthylique",
    "stéroïdes stérols",
    "stérols",
    "steak à braiser",
    "stilton",
    "lard strié",
    "lactosérum doux laitier",
    "lactosérum doux",
    "ris de veau",
    "lait concentré sucré",
    "espadon",
    "suif",
    "acide de suif",
    "amide de suif",
    "amine de suif",
    "oxyde d'amine de suif",
    "aminopropylamine de suif",
    "alcool gras de suif",
    "glycérides de suif",
    "imidazoline de suif hydroxyéthyle",
    "imidazoline de suif",
    "chlorure de trimonium de suif - suif",
    "oxyde de tallowamidopropylamine",
    "talloweth-6",
    "tallowmide dea",
    "tallowmide dea et mea",
    "tallowmide mea",
    "hydroxysultaïne tallowmidopropyle",
    "tallowminopropylamine",
    "tallowmphoacéte",
    "tea-abiétoyle hydrolysé protéine animale",
    "tea-coco protéine animale hydrolysée",
    "tea-lauroyle acides aminés de collagène animal",
    "tea-lauroyle acides aminés de kératine animale",
    "tea-myristol protéine animale hydrolysée",
    "tea-undécylénoyle protéine animale hydrolysée",
    "extrait testiculaire",
    "saucisse de Thuringe",
    "tilapia",
    "langue",
    "éthosulfate de protéine animale hydrolysée triéthonium",
    "trilaneth-4phosphate",
    "tripes",
    "alcools triterpènes",
    "truite",
    "trypsine",
    "thon",
    "dinde",
    "lard de dinde",
    "poitrine de dinde",
    "tortue",
    "huile de tortue",
    "huile de tortue de mer",
    "tyrosine",
    "lait non homogénéisé",
    "urée",
    "urée carbamide",
    "acide urique",
    "acide urique de vaches",
    "acide urique",
    "urine",
    "veau",
    "pain de veau",
    "chevreuil",
    "vitamine d ergocalciférol vitamine d",
    "vitamine h",
    "vitamineb",
    "facteur vitamineb",
    "volaise",
    "lactosérum",
    "poudre de lactosérum",
    "protéine de lactosérum",
    "crème fouettée",
    "garniture fouettée",
    "viande blanche",
    "lait entier",
    "yaourt au lait entier",
    "sanglier",
    "viande sauvage",
    "laine",
    "graisse de laine",
    "cire de laine",
    "alcools de cire de laine",
    "yaourt",
    "yaourt",
    "caséinate de zinc",
    "protéine animale hydrolysée de zinc"
]